<app-data-table
  [data]="addresses()"
  [columns]="columns"
  [isLoading]="isLoading()"
  [searchableFields]="[
    'street',
    'houseNumber',
    'postalCode',
    'city',
    'country',
    'roofType',
    'buildingType'
  ]"
  [rowActions]="actions()"
  [enableRowSelection]="showSelectionColumn()"
  [rowId]="getRowId"
  [serverSorting]="serverSorting()"
  (sortChange)="sortChange.emit($event)"
  [currentPage]="currentPage()"
  [totalPages]="totalPages()"
  [totalItems]="totalItems()"
  [isSelectingAll]="isSelectingAll()"
  addNewLabel="Neue Adresse"
  [showAddButton]="currentOrgStore.can('organization', 'createaddress')"
  searchPlaceholder="Straße, PLZ oder Ort suchen"
  emptyStateTitle="Keine Adressen vorhanden"
  emptyStateDescription="Es wurden noch keine Adressen angelegt"
  (addNew)="onAddNew()"
  (selectionIdsChanged)="onSelectionIdsChanged($event)"
  (requestSelectAll)="requestSelectAll.emit()"
  (pageChange)="pageChange.emit($event)"
>
</app-data-table>

<!-- Address Form Dialog (integrated) -->
<app-address-form
  [isOpen]="isFormOpen()"
  [organizationId]="organizationId()"
  [editAddress]="editingAddress()"
  (close)="onFormClose()"
  (addressSaved)="onAddressSaved($event)"
/>

<!-- Templates -->
<ng-template #addressTpl let-address>
  <span class="text-sm">{{ address.street }} {{ address.houseNumber }}</span>
</ng-template>

<ng-template #postalCodeTpl let-address>
  <span class="font-mono text-dense">{{ address.postalCode }}</span>
</ng-template>

<ng-template #cityTpl let-address>
  <span class="text-sm">{{ address.city }}@if (address.country && address.country !== "DE") {<span class="text-muted-foreground">, {{ address.country }}</span>}</span>
</ng-template>

<ng-template #countryTpl let-address>
  <span>{{ address.country }}</span>
</ng-template>

<ng-template #roofTypeTpl let-address>
  @if (getRoofTypeLabel(address.roofType) !== 'Unbekannt') {
    <span class="text-dense">{{ getRoofTypeLabel(address.roofType) }}</span>
  } @else {
    <span class="text-muted-foreground" aria-label="Unbekannt">—</span>
  }
</ng-template>

<ng-template #buildingTypeTpl let-address>
  <span class="text-dense">{{ address.isApartmentBuilding ? "Mehrfamilienhaus" : "Einfamilienhaus" }}</span>
</ng-template>
